import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgValidationFilledIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 22 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.1805 12.1635C11.4627 12.3073 11.6922 12.5368 11.836 12.819C11.9891 13.1194 11.9997 13.4476 11.9995 13.7769C11.9995 13.7847 11.9995 13.7924 11.9995 13.8C11.9995 15.2744 11.999 16.7488 11.9995 18.2231C11.9996 18.3422 11.9996 18.4845 11.9894 18.6098C11.9775 18.755 11.9471 18.963 11.836 19.181C11.6922 19.4632 11.4627 19.6927 11.1805 19.8365C10.9626 19.9476 10.7546 19.978 10.6093 19.9899C10.484 20.0001 10.3418 20.0001 10.2227 20C7.40722 19.999 4.59177 19.999 1.77633 20C1.65706 20.0001 1.5145 20.0001 1.38887 19.9898C1.24315 19.9778 1.03474 19.9472 0.816462 19.8356C0.533861 19.6911 0.303788 19.46 0.160599 19.1767C0.0502981 18.9585 0.0203853 18.7506 0.00901634 18.6046C-0.000751009 18.4791 -4.61244e-05 18.3369 0.000541399 18.2185C0.00569752 17.1792 -0.0252853 16.0653 0.380121 15.0866C0.887591 13.8614 1.86096 12.8881 3.0861 12.3806C3.5958 12.1695 4.13408 12.0819 4.74282 12.0404C5.33483 12 6.06224 12 6.964 12C8.05022 12 9.13644 12.0004 10.2227 12C10.5519 11.9999 10.8801 12.0104 11.1805 12.1635Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.7066 13.2929C22.0972 13.6834 22.0972 14.3166 21.7066 14.7071L17.7066 18.7071C17.3161 19.0976 16.6829 19.0976 16.2924 18.7071L14.2924 16.7071C13.9019 16.3166 13.9019 15.6834 14.2924 15.2929C14.6829 14.9024 15.3161 14.9024 15.7066 15.2929L16.9995 16.5858L20.2924 13.2929C20.6829 12.9024 21.3161 12.9024 21.7066 13.2929Z",
			opacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.49952 5C3.49952 2.23858 5.73809 0 8.49952 0C11.2609 0 13.4995 2.23858 13.4995 5C13.4995 7.76142 11.2609 10 8.49952 10C5.73809 10 3.49952 7.76142 3.49952 5Z"
		})
	]
});
export default SvgValidationFilledIcon;
